import React from "react";
import { Container, Row, Col } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import AccessoryProgressSteps from "./AccessoryProgressSteps";
import { AccessoryProvider } from "../../context/AccessoryContext";
import SelectedAccessorySeries from "../../components/AccessoryCreation/SelectedAccessorySeries";

function Accessory(props) {
  const { id, series, version } = props.match.params;
  return (
    <AccessoryProvider id={id} series={series} version={version}>
      <Header>
        <h1>
          <FormattedMessage id="accessories.new_accessory.title" defaultMessage="Create a new accessory" />
        </h1>
      </Header>
      <Container fluid>
        <SelectedAccessorySeries></SelectedAccessorySeries>
        <Row>
          <Col>
            <AccessoryProgressSteps {...props}></AccessoryProgressSteps>
          </Col>
        </Row>
      </Container>
    </AccessoryProvider>
  );
}

export default Accessory;
